import { Navigate } from "react-router-dom";
import { useSpecialRights } from "../../../context/SpecialRightsContext";

interface Props {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<Props> = ({ children }) => {
  const { hasSpecialRights } = useSpecialRights();

  if (!hasSpecialRights) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
